import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import { useLocale } from './../../components/special/LanguageProvider';
import ListHeader from './../../components/form/ListHeader';
import ListTable from './../../components/form/ListTable';
import RowButtons from './../../components/button/RowButtons';
import RowChangeButton from './../../components/button/RowChangeButton';
import TextDate from './../../components/text/TextDate';
import TextNumber from './../../components/text/TextNumber';
import RowDeleteButton from './../../components/button/RowDeleteButton';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const TableList = ({history})  => {
  const [list, setList] = useState([]);  
  const [tableInfo , setTableInfo] = useState({
    tableTypeID : null,
    name : "",
  });  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const params = new URLSearchParams(useLocation().search); 
  
  const goBack = () => {
    history.push("/admin/tabletypes");
  }

  const loadList = async () =>{
    let tabletypeID = params.get("tabletypeid");
    if (tabletypeID == null || tabletypeID <= 0){
      goBack();
    }
    else{
      const data = await apiGetCall(BASE_URL + '/admin/table/summary/'+tabletypeID);
      if (isResultOk(data, setListError, true)){
        setTableInfo({
          tableTypeID : data.tableTypeID,
          name : data.name,
        });
        setList(data.tables);
      }
      setListLoading(false);
    }
  }

  useEffect(() => {
    setIsPageLoading(true);
    loadList();
    setIsPageLoading(false);
  }, []);  

  const onDeleteTableClick = async(table) => {
    setIsPageLoading(true);
    let requestResult = await apiPostCall(BASE_URL + '/admin/table/remove', {TableTypeID: table.tableTypeID, TableID: table.tableID});
    if (isResultOk(requestResult, setCheckErrorItems)){
      await loadList();
    }
    setIsPageLoading(false);
  }
  
    return (
      <div>      
        <a href={"/admin/tabletypes"}>{t("Forsendutöflur")}</a>
        <ListHeader title={tableInfo.name}>                      
          <div className="text-right"><Link to={"/admin/tables/edit?new=true&tabletypeid="+tableInfo.tableTypeID} className="no-print button gray-light icon-plus pointer-edit text-14">{t("Stofna nýja töflu")}</Link></div>
        </ListHeader>
        <ListTable
            error = {listError}
            isLoading = {listLoading}
            list = {list}
            colsettings = {['', '120px', '120px','250px','250px','20px']}
            headers = {[
              t("Name"),
              t("Kóði"),
              t("Færslur"),
              t("Nýjasti punktur"),
              t("Gildandi punktur"),
              ''              
            ]}
            columns = {[
              (item => (<a href={"/admin/tablerates?tabletypeid="+tableInfo.tableTypeID+"&tableid=" + item.tableID}>{item.name}</a>)),
              (item => (<span>{item.tableCode}</span>)),
              (item => (<TextNumber value={item.numberOfPoints}/>)),              
              (item => (<>{item.newestPoint && (<><TextDate value={item.newestPoint.pointDate}/> <small>(<TextNumber value={item.newestPoint.value}/>)</small> </>)} </>)),
              (item => (<>{item.currentPoint && (<><TextDate value={item.currentPoint.pointDate}/> <small>(<TextNumber value={item.currentPoint.value}/>)</small> </>)} </>)),
              (item => (<>{!item.isReadonly && <RowButtons>
                            {item.numberOfPoints === 0 && <RowDeleteButton onClick={() => onDeleteTableClick(item)}/>}
                            <RowChangeButton link={"/admin/tables/edit?tabletypeid="+tableInfo.tableTypeID+"&tableid="+item.tableID}/>                    
                          </RowButtons>}</>))
            ]}
  
        />
    </div>
    );
};
